import { Button } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import store from 'stores/RootStore';
import { isSuperUserSiteRole } from 'types/Roles';

import AddClientModal from './AddClientModal';

function AddClientButton() {
  const parentDocument = store.clients;
  const creationEnabled = isSuperUserSiteRole(store.user.role);

  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Button
        disabled={!creationEnabled}
        onClick={() => setIsModalVisible(true)}
      >
        Add Client
      </Button>

      {creationEnabled && (
        <AddClientModal
          isVisible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          parentDocument={parentDocument}
        />
      )}
    </>
  );
}

export default observer(AddClientButton);
